import React  from "react";
import {useEffect,useState }  from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AxiosInstance from '../../../services/AxiosInstance';
import {RESOLVER_BY_RG_URL, USERS_URL, RESOLVER_URL} from '../../../Constants/Constants';
import Box from '@mui/material/Box';
import { useAlert } from "./../../alerts/AlertContext";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Grid from '@mui/material/Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Container from 'react-bootstrap/Container';
import Paper from '@mui/material/Paper';
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import AppTableView from "../../AppTableView";
import {ADD_USERS_TO_GROUP_COLUMNS} from "../../ticket/grid/GridDataConstants";

function AddUsersToGroupDialog({groupId, selectedGroupName, callGroups}){

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

    const [open, setOpen] = React.useState(false);
    const [groupName, setGroupName] = useState("");
    
    const [users, setUsers] = useState([]);
    const [userGroups, setUserGroups] = useState([]);

    const showAlert = useAlert();
    const [selectedOption, setSelectedOption] = useState(null);
        
    const [userGroup, setUserGroup] = useState({
        
        groupId: {},
        userIds: []        
      });

    useEffect(() => {        
        getUsers();
        getUserGroups();
    }, []);
    
    const handleClickOpen = async() => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGroupNameChange = (event) => {
        setGroupName(event.target.value);
    }

    
    const getUsers = () => {
        AxiosInstance.get(USERS_URL).then(response => setUsers(response.data.data));      
    }    

    const handleChange = (event, value) => {
        const userIds = value.map(user => user.id);
        setSelectedOption(userIds);
        console.log('Selected option:', value);
      };

    const addUserGroups = async () => {
        
        userGroup.groupId = groupId;
        userGroup.userIds = selectedOption;
        
        await AxiosInstance.post(RESOLVER_URL, userGroup)
        .then((response) => {      
            
            if (response.data){
                getUserGroups();
                showAlert("Add Group to Users done successfully!","success");
            }                
            else
                showAlert("Failed Add Group to Users!", "error");
        })
        .catch((error)=>{
            showAlert("Failed Add Group to Users!", "error");
            console.error(error);
        });
        
      };

    const [page, setPage] = React.useState(0);    
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [search, setSearch] = useState("");

    // Filter users based on search input
    // const filteredUsers = userRoles.filter(userRole =>
    //     userRole.user.name.toLowerCase().includes(search.toLowerCase()) ||
    //     userRole.role.name.toLowerCase().includes(search.toLowerCase())
    // );

    const filteredUsers = React.useMemo(() => {
        return userGroups.filter(userRole =>
            userRole.user.name.toLowerCase().includes(search.toLowerCase()) ||
            userRole.role.name.toLowerCase().includes(search.toLowerCase())
        );
      }, [search]);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
        
    const handleDeleteUserRole = (usrGroup) => {
        
        AxiosInstance.post(`${RESOLVER_URL}/${usrGroup}`).then(response => showAlert("Removed User  successfully!", "success")); 
        
        setUserGroups((uRoles) => uRoles.filter((item) => item.id !== usrGroup));
        
    };   

    const getUserGroups = () => {
        // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
        AxiosInstance.get(`${RESOLVER_BY_RG_URL}/${groupId}`).then(response => setUserGroups(response.data)); 
        
    };   


    const displayRows = React.useMemo(
        () =>
          [...userGroups]            
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [userGroups, page, rowsPerPage],
      );

    // const displayRows = React.useMemo(() => {
    //     return filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //   }, [filteredUsers, page, rowsPerPage]);


    return(
        <React.Fragment>
                
                <GroupAddIcon style={{cursor:"pointer"}} onClick={handleClickOpen}/>
                
                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();                        
                        //saveRole();                    
                        handleClose();
                    },
                    }}
                >
                    <DialogTitle>{'Assign Group'}</DialogTitle>
                    <DialogContent>
                        <Box
                            component="form"                        
                            sx={{ '& .MuiTextField-root': { m: 1, width: '50ch' } }}
                            noValidate
                            autoComplete="off"
                        >

                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="rg"
                                name="groupName"
                                label="Group Name"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={selectedGroupName}
                                disabled
                                onChange={handleGroupNameChange}                    
                            />
                            <Grid container spacing={2} columns={16}>
                            <Grid size={13}>                
                            <Autocomplete
                                multiple
                                limitTags={2}
                                id="checkboxes-tags-demo"
                                size="small"                    
                                options={users}
                                onChange={handleChange}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.name}
                                renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                    </li>
                                );
                                }}
                                style={{ width: "100%" }}
                                renderInput={(params) => (
                                <TextField {...params} label="Users" placeholder="Users" />
                                )}
                            />
                            </Grid>
                            <Grid size={3}>
                                <Button variant="contained" color="primary" style={{marginTop:"7px"}} onClick={addUserGroups}>
                                    Add
                                </Button>

                            </Grid>
                        </Grid>
                        {displayRows.length > 0 ? (
                            <Container fluid>

                                <Box sx={{width: '100%'}}>
                                    <Paper sx={{width: '100%', mb: 2}}>
                                        {/* <TextField
                                label="Search"
                                variant="outlined"
                                fullWidth
                                margin="dense"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            /> */}
                                        <TableContainer component={Paper}>

                                            <AppTableView
                                                rows={userGroups}
                                                cols={ADD_USERS_TO_GROUP_COLUMNS({handleDeleteUserRole})}
                                                initialPageSize={5}
                                                rowHeight={100}
                                            />

                                        </TableContainer>

                                    </Paper>
                                </Box>
                            </Container>
                        ) : (
                            <p>No data available</p> 
                          )}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button type="submit">Add </Button> */}
                    </DialogActions>
                </Dialog>
                </React.Fragment>
    )
}
export default AddUsersToGroupDialog;